import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { QueryClient, useQueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

import React from 'react';

export { useQueryClient };

export const CACHE_PREFIX = 'CACHE' as const;

/** NOTE - ONLY use this explicitly when it can not be injected via `useQueryClient` or at the very top level of the app */
export const ourQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // NOTE - we have our own opt-in retry logic in the API
      retry: false,
      refetchOnWindowFocus: false,
      networkMode: 'always'
    },
    mutations: {
      networkMode: 'always'
    }
  }
});

const persister = createSyncStoragePersister({
  storage: window.localStorage
});

export const QueryProvider = (props: {
  children: React.ReactElement;
  devToolProps?: Parameters<typeof ReactQueryDevtools>;
}) => {
  const { children, devToolProps } = props;

  return (
    <QueryClientProvider client={ourQueryClient}>
      <PersistQueryClientProvider
        client={ourQueryClient}
        persistOptions={{
          persister,
          dehydrateOptions: {
            shouldDehydrateQuery: (query) => query.queryKey[0] === CACHE_PREFIX,
            shouldRedactErrors: (_error) => false
          }
        }}>
        {children}
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition={'bottom-left'}
          {...(devToolProps ? devToolProps[0] : undefined)}
        />
      </PersistQueryClientProvider>
    </QueryClientProvider>
  );
};
